import { CheckCircle2, CreditCard } from 'lucide-react'

const formatDate = value => {
  if (!value) return null

  return new Date(value).toLocaleDateString('es-CL', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  })
}

const PaymentCardSelector = ({
  cards = [],
  selectedCardId = '',
  onSelectCard,
  className = '',
  disabled = false
}) => {
  return (
    <div className={`grid gap-4 ${className}`.trim()}>
      {cards.map(card => {
        const isSelected = String(card.id) === String(selectedCardId)
        const savedDate = formatDate(card.createdAt)

        return (
          <button
            key={card.id}
            type='button'
            disabled={disabled}
            onClick={() => onSelectCard?.(String(card.id))}
            className={`w-full rounded-[24px] border p-5 text-left font-sans shadow-sm transition-all ${
              isSelected
                ? 'border-accent2 bg-accent2/5 ring-2 ring-accent2/20'
                : 'border-slate-200 bg-white hover:border-accent2/35 hover:shadow-md'
            } ${disabled ? 'cursor-not-allowed opacity-70' : ''}`}
          >
            <div className='flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between'>
              <div className='flex items-start gap-4'>
                <div
                  className={`flex h-12 w-12 items-center justify-center rounded-full ${
                    isSelected ? 'bg-accent2 text-white' : 'bg-slate-100 text-slate-500'
                  }`}
                >
                  <CreditCard className='h-5 w-5' />
                </div>

                <div>
                  <div className='flex flex-wrap items-center gap-2'>
                    <p className='text-lg font-sans font-bold text-slate-800'>
                      {card.name ||
                        `${card.cardType?.toUpperCase?.() || 'Tarjeta'} **** ${
                          card.lastFourDigits
                        }`}
                    </p>
                    {isSelected && (
                      <span className='inline-flex items-center gap-1 rounded-full bg-accent2 px-3 py-1 text-[11px] font-sans font-semibold uppercase tracking-[0.16em] text-white'>
                        <CheckCircle2 className='h-3.5 w-3.5' />
                        Seleccionada
                      </span>
                    )}
                  </div>

                  <p className='mt-1 text-sm font-sans text-slate-600'>
                    {(card.cardType || 'Tarjeta').toUpperCase()} **** {card.lastFourDigits}
                  </p>

                  {savedDate && (
                    <p className='mt-1 text-xs font-sans text-slate-500'>Guardada el {savedDate}</p>
                  )}
                </div>
              </div>

              <div
                className={`inline-flex items-center justify-center rounded-full px-4 py-2 text-sm font-sans font-semibold ${
                  isSelected
                    ? 'bg-accent2 text-white'
                    : 'border border-slate-200 bg-white text-slate-700'
                }`}
              >
                {isSelected ? 'Lista para usar' : 'Usar esta tarjeta'}
              </div>
            </div>
          </button>
        )
      })}
    </div>
  )
}

export default PaymentCardSelector
